import { longbeach_paths_october, arr_longbeach_paths_2026 } from "./longbeach_paths";
import transformToDate from "../../transformToDate";


export const longbeach_backpack_2026 = [
   {
   url: `${process.env.REACT_APP_LIDAR_CDN_URL}/portoflongbeach_ca_processed/Area1-15_NAVVIS`,
    name: `Longbeach CA - Area 1-15 NAVVIS`,
    description: `Scan of processed Longbeach CA on backpack LiDAR (Area 1-15)`,
    date_uploaded: new Date('02/14/2026'),
    data_identifier: 'longbeach_ca',
    collector: 'portoflongbeach_backpack_collector',
    projection: "+proj=lcc +lat_1=35.46666666666667 +lat_2=34.03333333333333 +lat_0=33.5 +lon_0=-118 +x_0=2000000.0001016 +y_0=500000.0001016001 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +to_meter=1 +no_defs"
  }
];


export const longbeach_paths_2026 = async (accessToken) => {
  try {
    const paths = await arr_longbeach_paths_2026(accessToken);
    return paths;
  } catch (error) {
    console.error('Error fetching longbeach paths:', error);
    return [];
  }
};